@if (loaderService.loaderIsActive()) {
<sheba-loader></sheba-loader>
}
@if(lightMode()){
<!-- <div class="fixed w-full z-50">-->
@if (translationsLoaded()) {
  <sheba-skip-to-main-content />
}
<sheba-header [headerData]="sharedService.header()" [footerData]="sharedService.footer()" />
<!--</div>-->
}

<router-outlet></router-outlet>

@if(lightMode()){
<sheba-footer [footerData]="sharedService.footer()" />
}
